import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from "react-i18next";
import { app, dialog, DialogSize, UrlDialogInfo } from "@microsoft/teams-js";
import './draftMessages.scss';
import { selectMessage, getDraftMessagesList, getScheduledMessagesList, getMessagesList } from '../../actions';
import { getBaseUrl } from '../../configVariables';
import Overflow from '../OverFlow/draftMessageOverflow';
import { TFunction } from "i18next";
import { Spinner, Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell, TableCellLayout, Text } from '@fluentui/react-components';
import { Chat24Regular } from '@fluentui/react-icons';

export interface ITaskInfo {
  title?: string;
  height?: number;
  width?: number;
  url?: string;
  card?: string;
  fallbackUrl?: string;
  completionBotId?: string;
}

export interface IMessage {
  id: string;
  title: string;
  date: string;
  recipients: string;
  acknowledgements?: string;
  reactions?: string;
  responses?: string;
  updateType: string;
}

export interface IMessageProps extends WithTranslation {
  messages: IMessage[];
  selectedMessage: any;
  selectMessage?: any;
  getDraftMessagesList?: any;
  getMessagesList?: any;
  getScheduledMessagesList?: any;
  resetPageCallback?: any;
}

export interface IMessageState {
  message: IMessage[];
  itemsAccount: number;
  loader: boolean;
  teamsTeamId?: string;
  teamsChannelId?: string;
}

class DraftMessages extends React.Component<IMessageProps, IMessageState> {
  readonly localize: TFunction;
  private interval: any;
  private isOpenTaskModuleAllowed: boolean;

  constructor(props: IMessageProps) {
    super(props);
    this.localize = this.props.t;
    this.isOpenTaskModuleAllowed = true;
    this.state = {
      message: props.messages,
      itemsAccount: this.props.messages.length,
      loader: true,
      teamsTeamId: "",
      teamsChannelId: "",
    };
  }

  public componentDidMount() {
    app.initialize().then(() => {
      app.getContext().then((context: app.Context) => {
        this.setState({
          teamsTeamId: context.team?.internalId,
          teamsChannelId: context.channel?.id,
        });
      });
    });
    this.props.getDraftMessagesList();
    this.interval = setInterval(() => {
      this.props.getDraftMessagesList();
    }, 60000);
  }

  public componentWillReceiveProps(nextProps: any) {
    this.setState({
      message: nextProps.messages,
      loader: false
    })
  }

  public componentWillUnmount() {
    clearInterval(this.interval);
  }

  private resetPage = (reset: boolean) => {
    this.props.resetPageCallback(true);
  }

  public render(): JSX.Element {
    if (this.state.loader) {
      return (
        <Spinner />
      );
    } else if (this.state.message.length === 0) {
      return (<div className="results">{this.localize("EmptyDraftMessages")}</div>);
    }
    else {
      return (
        <div className='list'>
          <Table arial-label="Default table" size='medium'>
            <TableHeader>
              <TableRow>
                <TableHeaderCell key="title">
                  <Text weight='bold' truncate={true} wrap={false}>{this.localize("TitleText")}</Text>
                </TableHeaderCell>
                <TableHeaderCell key="actions"></TableHeaderCell>
              </TableRow>
            </TableHeader>
            <TableBody>
              {this.state.message.map((item) => (
                <TableRow key={item.id} onClick={(e) => this.onRowClick(item)}>
                  <TableCell>
                    <div className='title-container'>
                      <Chat24Regular />
                      <Text truncate={true} wrap={false}>{item.title}</Text>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Overflow message={item} resetPageCallback={this.resetPage} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    }
  }

  private onRowClick = (message: IMessage) => {
    const url = getBaseUrl() + "/newmessage/draft/" + message.id + "?locale={locale}";
    this.onOpenTaskModule(null, url, this.localize("EditMessage"));
  }

  private onOpenTaskModule = (event: any, url: string, title: string) => {
    if (this.isOpenTaskModuleAllowed) {
      this.isOpenTaskModuleAllowed = false;
      let taskInfo: UrlDialogInfo = {
        url: url,
        title: title,
        size: {
          height: 660,
          width: 1000
        } as DialogSize,
        fallbackUrl: url,
      }

      let submitHandler = (result: dialog.ISdkResponse) => {
        this.props.getDraftMessagesList().then(() => {
          this.props.getScheduledMessagesList();
          this.isOpenTaskModuleAllowed = true;
        });
      };

      dialog.url.open(taskInfo, submitHandler);
    }
  }
}

const mapStateToProps = (state: any) => {
  return { messages: state.draftMessagesList, selectedMessage: state.selectedMessage };
}

const draftMessagesWithTranslation = withTranslation()(DraftMessages);
export default connect(mapStateToProps, { selectMessage, getDraftMessagesList, getScheduledMessagesList, getMessagesList })(draftMessagesWithTranslation);